var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"switcher",class:{ 'switcher--on': _vm.turn, 'switcher--off': !_vm.turn},on:{"click":_vm.clickHandler}},[_vm._m(0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"switcher__bar"},[_c('div',{staticClass:"switcher__circle"})])
}]

export { render, staticRenderFns }